<template>
    <card id='departure-transfers'>
        <!-- <CardHeader :title="$t('departure_transfers.departure_transfers')"  /> -->
        
        <h4>
            <b-icon icon="box-arrow-in-right"></b-icon>
            <span>{{ $t('departure_transfers.departure_transfers') }}</span>
            <a v-if="!selectedTransfer" href="#" class="action-link" @click="onNewItem" v-b-tooltip :title="$t('button.add')"><b-icon icon="plus-circle-fill" scale="1.0"></b-icon></a>
            <a v-else  href="#" class="action-link" @click="onReset" v-b-tooltip :title="$t('button.close')"><b-icon icon="x" scale="1.8"></b-icon></a>
         </h4>


        <div v-if="!selectedTransfer">
           <!-- <TableActionHeader @newItem="onNewItem" :searchInput="false" /> -->
            <div v-if="!items || items.length == 0" class='info note'>
                {{ $t('departure_transfers.empty') }}
            </div>
            <div v-else>
            <b-table
                style="white-space: pre-line;"
                small
                striped
                hover
                selectable
                select-mode="single"
                @row-selected="onRowSelected"
                :fields="fields"
                :items="items"
                :per-page="perPage"
                :current-page="currentPage"
                thead-tr-class="departure-transfer-headtr"
                tbody-tr-class="departure-transfer-bodytr">
                <template v-slot:cell(state)="data">
                    <DepartureTransferState :startTime="data.item.startTime" :endTime="data.item.endTime" />
                </template>
            </b-table>
            <TablePagination 
                :total-rows="totalRows" 
                :per-page="perPage" 
                @pageChange="onPageChange">
            </TablePagination>
            </div>
        </div>
        <div v-else>
              <form>
                <b-row>
                    <b-col>
                        <label>{{ $t('departure_transfers.source_platform') }}</label>
                        <vSelect :options="platformOptions" 
                                 :reduce="option => option.id" 
                                 label="name" 
                                 :disabled="loading"
                                 v-model="selectedTransfer.sourceStop" 
                                 :selectable="(option) => option.id != selectedTransfer.destinationStop" />
                     </b-col>
                    <b-col>
                        <label>{{ $t('departure_transfers.destination_platform') }}</label>
                        <vSelect :options="platformOptions" 
                                 :reduce="option => option.id" 
                                 label="name" 
                                 :disabled="loading"
                                 v-model="selectedTransfer.destinationStop" 
                                 :selectable="(option) => option.id != selectedTransfer.sourceStop" />
                    </b-col>
                </b-row>


                <b-form-group :label="$t('departure_transfers.lines')" v-if="lineOptions.length > 0">
                    <div v-for="line in lineOptions" :key="'line-'+ line" class='checkbox-list-item'>
                        <input type="checkbox" :id="line" :value="line" v-model="selectedTransfer.lines" :disabled="loading">
                        <label :for="line">{{ line }}</label>
                    </div>
                </b-form-group>

                <b-row>
                    <b-col>
                        <label>{{ $t('departure_transfers.start_time') }}</label>
                        <DateTimePicker v-model="selectedTransfer.startTime" :disabled="selectedTransfer.indefinite || loading" />
                    </b-col>
                    <b-col>
                        <label>{{ $t('departure_transfers.end_time') }}</label>
                        <DateTimePicker v-model="selectedTransfer.endTime" :disabled="selectedTransfer.indefinite || loading" />
                    </b-col>
                </b-row>
                
                <div class="mb-3">
                    <div class='float-right'>
                    <input type="checkbox" v-model="selectedTransfer.indefinite" :disabled="loading" style='margin-right: 8px;'>
                    <label> {{  $t('departure_transfers.indefinite') }} </label>
                    </div>
                </div>

                <FormButtons @submit="onSubmit" @reset="onReset" :remove="action == 'edit'" @remove="onRemove"></FormButtons>
                <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />


            </form>
            <!--
            <form>
                <b-form-group :label="$t('departure_transfers.source_platform')">
                    <vSelect :options="platformOptions" :reduce="option => option.id" label="name" :disabled="loading"
                        v-model="selectedTransfer.sourceStop" :selectable="(option) => option.id != selectedTransfer.destinationStop"  />
                </b-form-group>
                <b-form-group :label="$t('departure_transfers.destination_platform')">
                    <vSelect :options="platformOptions" :reduce="option => option.id" label="name" :disabled="loading"
                        v-model="selectedTransfer.destinationStop" :selectable="(option) => option.id != selectedTransfer.sourceStop" />
                </b-form-group>
                <b-form-group :label="$t('departure_transfers.lines')">
                    <div v-for="line in lineOptions" :key="'line-'+ line">
                        <input type="checkbox" :id="line" :value="line" v-model="selectedTransfer.lines" :disabled="loading">
                        <label :for="line">{{ line }}</label>
                    </div>
                </b-form-group>
                <b-form-group :label="$t('departure_transfers.indefinite')">
                    <input type="checkbox" v-model="selectedTransfer.indefinite" :disabled="loading">
                </b-form-group>
                <b-form-group :label="$t('departure_transfers.start_time')">
                    <DateTimePicker v-model="selectedTransfer.startTime" :disabled="selectedTransfer.indefinite || loading" />
                </b-form-group>
                <b-form-group :label="$t('departure_transfers.end_time')">
                    <DateTimePicker v-model="selectedTransfer.endTime" :disabled="selectedTransfer.indefinite || loading" />
                </b-form-group>
                <FormButtons @submit="onSubmit" @reset="onReset" :remove="action == 'edit'" @remove="onRemove"></FormButtons>
                <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />
            </form>
            -->
        </div>
        <div>
            <DepartureTransferGroups :terminalId="terminalId" :activeTerminalId="activeTerminalId" />
        </div>
    </card>
</template>

<script>
import terminalView from '@/store/terminals/terminalView';
import DepartureTransferGroups from '@/components/Terminals/DepartureTransferGroups.vue';
import DepartureTransferState from '@/components/Terminals/DepartureTransferState.vue';
import moment from 'moment';
import vSelect from 'vue-select';
import TablePagination from '@/components/Misc/TablePagination'
import DateTimePicker from '@/components/Misc/DateTimePicker'

export default {
	name: 'DepartureTransfers',
    props: ['terminalId', 'activeTerminalId'],
    components: { vSelect, TablePagination, DepartureTransferGroups, DepartureTransferState, DateTimePicker },
    data: function() {
        return {
            ok: false,
            error: false,
            loading: false,
            infoType: 'save',
            perPage: 7,
            currentPage: 1,
            selectedTransfer: null,
            action: 'add'
        };
    },
    computed: {
        fields() {
            return [
                { key: 'state' , label: this.$t('departure_transfers.state.table_header'), sortable: false },
                { key: 'sourcePlatform' , label: this.$t('departure_transfers.source_platform'), sortable: false },
                { key: 'destinationPlatform' , label: this.$t('departure_transfers.destination_platform'), sortable: false },
                { key: 'lines' , label: this.$t('departure_transfers.lines'), sortable: false, formatter: (value, key, item) => {
                    var lineList = '';
                    for (var line of item.lines) {
                        lineList += line;
                        lineList += ' ';
                    }
                    return lineList;
                }},
                { key: 'active', label: this.$t('departure_transfers.active'), sortable: false, formatter: (value, key, item) => {
                        var time = new moment(item.startTime, 'YYYY-MM-DD[T]HH:mm:ssZZ').format('DD.MM.YYYY HH:mm');
                        if (time.startsWith('Invalid')) {
                            return this.$t('departure_transfers.indefinitely');
                        }
                        time += ' -\n';
                        var time2 = new moment(item.endTime, 'YYYY-MM-DD[T]HH:mm:ssZZ').format('DD.MM.YYYY HH:mm');
                        if (time2.startsWith('Invalid')) {
                            return this.$t('departure_transfers.indefinitely');
                        }
                        return time + time2;
                    }
                }
            ];
        },
        items() {
             return this.$store.state.terminalView.departureTransfersByTerminal[this.terminalId];
        },
        platformOptions() {
            let optionList = [];
            for (var stop of this.terminalStops) {
                optionList.push({ id: stop.stopId, name: stop.platform });
            }
            
            return optionList;
        },
        lineOptions() {
            var optionList = [];
            if (this.selectedTransfer) {
                for (var stop of this.terminalStops) {
                    if (stop.stopId == this.selectedTransfer.sourceStop) {
                        for (var line of stop.availableLines) {
                            optionList.push(line);
                        }
                        break;
                    }
                }
            }
            return optionList;
        },
        totalRows() {
            return this.items ? this.items.length : 0;
        },
        terminalStops(){
            let stops = this.$store.state.terminalView.stopsByTerminal[this.terminalId];
            return stops ? stops : [];
        }
    },
    methods: {
        onNewItem() {
            this.selectedTransfer = { lines: []  };
            this.action = 'add';
        },
        onRowSelected(items) {
            if (items[0]) {
                this.selectedTransfer = { ...items[0] }; // Copy.
                this.action = 'edit';
            }
        },
        onReset() {
            this.selectedTransfer = null;
            this.ok = this.error = false;
            this.loading = this.disabled = false;
        },
        onSubmit(event) {
            if (event)
                event.preventDefault();
            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = this.disabled = true;

            this.$store.dispatch('terminalView/saveDepartureTransfer', { departureTransfer: this.selectedTransfer,
                                                                        terminalId: this.terminalId })
            .then(response => {
                setTimeout(() => { 
                    this.loading = this.disabled = false;
                    if (response.data.errorCode == 0) {
                        this.selectedTransfer = null;
                    } else {
                        this.error = true;
                    }
                }, 1000);
            })
            .catch( () => { this.error = true; })
        },
        onRemove() {
            this.ok = this.error = false;
            this.infoType = "delete";
            this.loading = this.disabled = true;
            this.$store.dispatch('terminalView/deleteDepartureTransfers', { departureTransferIds: this.selectedTransfer.departureTransferIds,
                                                                        terminalId: this.terminalId })
            .then(response => {
                setTimeout(() => { 
                    this.loading = this.disabled = false;
                    if (response.data.errorCode == 0) {
                        this.selectedTransfer = null;
                    } else {
                        this.error = true;
                    }
                }, 1000);
            }, () => {
                    this.ok = false;
                    this.error = !this.ok;
                    this.loading = this.disabled = false;
            });
        },
        onPageChange(page) {
            this.currentPage = page;
        }
    },
    watch: {
        activeTerminalId() {
            if (this.terminalId == this.activeTerminalId) {
                this.$store.dispatch('terminalView/getTerminalDepartureTransfers', this.terminalId);
                this.$store.dispatch('terminalView/getTerminalStops', this.terminalId);
            }
        }
    },
    created() {
        if (!this.$store.state.terminalView) {
            this.$store.registerModule("terminalView", terminalView);
        }
        this.$store.dispatch('terminalView/getTerminalDepartureTransfers', this.terminalId);
        this.$store.dispatch('terminalView/getTerminalStops', this.terminalId);
    }
};
</script>

<style lang="scss">
#departure-transfers {
    //height: 400px;
}

.departure-transfer-headtr th {
    font-size: 11px !important;
    padding: 5px !important;
}

.departure-transfer-bodytr td {
    font-family: Verdana,Arial,Helvetica,sans-serif;
    font-size: 11px;
    color: #515151;
    padding: 2px 2px 2px 5px !important;
}


</style>
